<mat-menu #compositionMenu="matMenu" class="line-composition-menu" xPosition="after">
  <ng-template matMenuContent>
    <!-- stopPropagation so opening the breakdown never navigates to the order row -->
    <div class="line-composition" *ngIf="composition as c" (click)="$event.stopPropagation()">
      <div class="lc-header">
        <span class="lc-title">{{ 'quotations_and_orders.line_composition.title' | translate }}</span>
        <span class="lc-order" *ngIf="orderName">{{ orderName }}</span>
      </div>

      <div class="lc-total">
        <span class="lc-total-value">{{ totalLines }}</span>
        <span class="lc-total-label">
          {{ (totalLines === 1 ? 'quotations_and_orders.line_composition.line_item' : 'quotations_and_orders.line_composition.line_items') | translate }}
        </span>
      </div>

      <ui-segmented-bar
        class="lc-bar"
        [segments]="segments"
        [ariaLabel]="'quotations_and_orders.line_composition.title' | translate"
      ></ui-segmented-bar>

      <ul class="lc-legend">
        <li class="lc-legend-row" *ngFor="let row of legend">
          <span class="lc-dot" [class]="'lc-dot lc-dot--' + row.tone"></span>
          <span class="lc-legend-label">{{ row.labelKey | translate }}</span>
          <span class="lc-legend-count">{{ row.count }}</span>
          <span class="lc-legend-percent">{{ row.percent }}%</span>
        </li>
      </ul>

      <div class="lc-divider"></div>

      <ul class="lc-meta">
        <li class="lc-meta-row">
          <ui-svg-icon class="lc-meta-icon" svgIcon="package" size="small"></ui-svg-icon>
          <span class="lc-meta-label">{{ 'quotations_and_orders.line_composition.unique_skus' | translate }}</span>
          <span class="lc-meta-value">{{ c.total_skus }}</span>
        </li>
        <li class="lc-meta-row">
          <ui-svg-icon class="lc-meta-icon" svgIcon="box" size="small"></ui-svg-icon>
          <span class="lc-meta-label">{{ 'quotations_and_orders.line_composition.total_quantity' | translate }}</span>
          <span class="lc-meta-value">{{ c.total_quantity }}</span>
        </li>
      </ul>
    </div>
  </ng-template>
</mat-menu>
